<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.33301 12.5L8.33301 10"
      stroke="url(#paint0_linear_3193_9195)"
      stroke-width="1.2"
      stroke-linecap="round"
    />
    <path
      d="M11.667 12.5L11.667 10"
      stroke="url(#paint1_linear_3193_9195)"
      stroke-width="1.2"
      stroke-linecap="round"
    />
    <path
      d="M2.5 5.83203H17.5V5.83203C17.0353 5.83203 16.803 5.83203 16.6098 5.87046C15.8164 6.02827 15.1962 6.64847 15.0384 7.44185C15 7.63505 15 7.86738 15 8.33203V12.6654C15 14.551 15 15.4938 14.4142 16.0796C13.8284 16.6654 12.8856 16.6654 11 16.6654H9C7.11438 16.6654 6.17157 16.6654 5.58579 16.0796C5 15.4938 5 14.551 5 12.6654V8.33203C5 7.86738 5 7.63505 4.96157 7.44185C4.80376 6.64847 4.18356 6.02827 3.39018 5.87046C3.19698 5.83203 2.96466 5.83203 2.5 5.83203V5.83203Z"
      stroke="url(#paint2_linear_3193_9195)"
      stroke-width="1.2"
      stroke-linecap="round"
    />
    <path
      d="M8.39045 2.80883C8.48541 2.72023 8.69465 2.64194 8.98572 2.5861C9.2768 2.53027 9.63343 2.5 10.0003 2.5C10.3672 2.5 10.7239 2.53027 11.0149 2.5861C11.306 2.64194 11.5152 2.72023 11.6102 2.80883"
      stroke="url(#paint3_linear_3193_9195)"
      stroke-width="1.2"
      stroke-linecap="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_3193_9195"
        x1="8.33301"
        y1="11.25"
        x2="9.33301"
        y2="11.25"
        gradientUnits="userSpaceOnUse"
      >
        <stop class="gradient-start" stop-color="#437BE8" />
        <stop class="gradient-end" offset="1" stop-color="#0F8DFB" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_3193_9195"
        x1="11.667"
        y1="11.25"
        x2="12.667"
        y2="11.25"
        gradientUnits="userSpaceOnUse"
      >
        <stop class="gradient-start" stop-color="#437BE8" />
        <stop class="gradient-end" offset="1" stop-color="#0F8DFB" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_3193_9195"
        x1="10"
        y1="5.83203"
        x2="10"
        y2="16.6654"
        gradientUnits="userSpaceOnUse"
      >
        <stop class="gradient-start" stop-color="#437BE8" />
        <stop class="gradient-end" offset="1" stop-color="#0F8DFB" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_3193_9195"
        x1="10.0003"
        y1="2.5"
        x2="10.0003"
        y2="3.33333"
        gradientUnits="userSpaceOnUse"
      >
        <stop class="gradient-start" stop-color="#437BE8" />
        <stop class="gradient-end" offset="1" stop-color="#0F8DFB" />
      </linearGradient>
    </defs>
  </svg>
</template>

<style lang="scss">
.text-red {
  svg {
    // Option A: Change all stops to a single solid red override
    stop {
      stop-color: #df252a;
    }

    // Option B: Target distinct stops using specific classes
    .gradient-start {
      stop-color: #ff5f56;
    }
    .gradient-end {
      stop-color: #df252a;
    }
  }
}
</style>
